// src/store/useUserBookingsStore.ts
import { createStore } from "zustand";
import { useStore } from "zustand";
import { persist } from "zustand/middleware";
import type { InitialUserBookingsState, UserBookingsState } from "./types";

const initialState: InitialUserBookingsState = {
  userBookings: null,
  errorMessage: null,
  isLoading: false,
};

// Using persist middleware to keep user bookings state after page refresh
export const userBookingsStore = createStore<UserBookingsState>()(
  persist(
    (set) => ({
      ...initialState,
      setUserBookings: (userBookings) =>
        set({
          userBookings,
          errorMessage: null,
          isLoading: false,
        }),
      clearUserBookings: () =>
        set({
          userBookings: null,
          errorMessage: null,
          isLoading: false,
        }),
      deleteBookingTimeSlot: () =>
        set({
          isLoading: true,
          errorMessage: null,
        }),
      deleteBookingTimeSlotSuccess: (
        userBookingId: number,
        bookingTimeSlotId: number
      ) =>
        set((state) => ({
          userBookings: state.userBookings?.map((userBooking) => {
            if (userBooking.id === userBookingId) {
              return {
                ...userBooking,
                bookedTimeSlots: userBooking.bookedTimeSlots.filter(
                  (b) => b.id !== bookingTimeSlotId
                ),
              };
            }
            return userBooking;
          }),
          isLoading: false,
        })),
      setError: (message) => set({ errorMessage: message }),
      setLoading: (loading) => set({ isLoading: loading }),
    }),
    {
      name: "user-bookings-storage", // key for localStorage
      partialize: (state) => ({
        userBookings: state.userBookings,
      }),
    }
  )
);

export const useUserBookingsStore = <T>(
  selector: (state: UserBookingsState) => T
) => useStore(userBookingsStore, selector);
